export default __webpack_public_path__ + "static/virtue-c783e3a3fb8605cfaddf89c74a2cbef0.png";